import React, { useRef } from 'react';
import { BlazeTableColDef, BlazeTableOptions } from 'components/blazeTable/BlazeTable.types';
import BlazeTable from 'components/blazeTable/BlazeTable';
import { MsgComponent } from 'types/rest/assetCatalogTypes';

interface MsgConnectionTableProps {
  msgComponentList: MsgComponent[];
  onSelectionChange: (selectedItems: Array<any>) => void;
  isLoading: boolean;
  page: number;
  totalElements: number;
  noResultsText: string;
  headerText: string;
}

const MsgConnectionTable = (props: MsgConnectionTableProps) => {
  const tableRef = useRef<BlazeTable>(null);

  const colsDefinition: BlazeTableColDef[] = [
    {
      header: props.headerText,
      accessor: 'name',
      isSortable: true,
    },
  ];

  const tableOptions: BlazeTableOptions = {
    isRowExpandable: () => false,
    showRowExpander: false,
    columnDef: colsDefinition,
    pageable: true,
    selectable: true,
    selectAllDropdown: true,
    pageSize: 5,
    sortable: true,
    tableName: 'ConnectionComponentsList',
    noResultsText: props.noResultsText,
    customHeaderClassName: 'flex-table-item-top',
    customTableClassName: 'flex-table-simple flex-table-condensed',
  };

  return (
    <BlazeTable
      onSelectionChange={props.onSelectionChange}
      options={tableOptions}
      data={props.msgComponentList}
      isLoading={props.isLoading}
      ref={tableRef}
      showPageSizeDropdown={true}
      pageSizeOptions={[5, 10]}
      paginationClassName={'justify-content-lg-end'}
    />
  );
};

export default MsgConnectionTable;
